import React, { ReactElement } from 'react';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Breadcrumb from './Breadcrumb';
import { makeStyles, Theme } from '@material-ui/core/styles';

interface BreadcrumbProps {
  breadcrumbs: any[];
}

const useStyles = makeStyles((theme: Theme) => {
  return {
    container: {
      background: theme.palette.common.white,
      padding: `${theme.spacing(0.5)}px ${theme.spacing(5)}px`
    }
  };
});

const renderBreadcrumbs = (breadcrumbs: any[]): React.ReactElement[] => {
  return breadcrumbs.map((x, idx) => {
    return (
      <Breadcrumb
        key={x.path}
        url={x.path}
        name={x.name}
        Icon={x.Icon}
        selected={idx === breadcrumbs.length - 1}
      />
    );
  });
};

const BreadcrumbBar = ({ breadcrumbs }: BreadcrumbProps): ReactElement => {
  const classes = useStyles();

  return (
    <Breadcrumbs className={classes.container} aria-label="breadcrumb">
      {renderBreadcrumbs(breadcrumbs)}
    </Breadcrumbs>
  );
};

export default BreadcrumbBar;
